import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { formatSAR } from "@/lib/utils";
import { ArrowRight, Check } from "lucide-react";

export default function PackagesSection({ catalog, vehicleType = "hiace" }) {
  const { t } = useApp();
  const nav = useNavigate();
  if (!catalog?.settings?.packages?.length) return null;
  const { prices } = catalog.settings;
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 py-20" data-testid="packages-section">
      <div className="mb-10"><div className="text-xs uppercase tracking-widest text-emerald-700 font-bold mb-2">{t("packages")}</div>
        <h2 className="text-3xl sm:text-4xl font-bold">{t("packages_title")}</h2><p className="text-slate-500 mt-2">{t("packages_sub")}</p></div>
      <div className="grid md:grid-cols-3 gap-6">
        {catalog.settings.packages.map((p) => {
          const total = p.trips.reduce((a, tr) => a + (prices[`${tr.service_type}|${tr.route}|${vehicleType}`] || 0), 0);
          const fixed = p.price_mode === "fixed" ? p.fixed_prices?.[vehicleType] : null;
          const final = fixed > 0 ? Math.round(fixed) : Math.round(total * (1 - (p.discount_percent || 0) / 100));
          const savePct = total > 0 ? Math.round((1 - final / total) * 100) : 0;
          return (
            <div key={p.id} className="abdan-card flex flex-col relative overflow-hidden" data-testid={`package-${p.id}`}>
              {p.image && <img src={p.image} alt={p.name} className="w-full h-40 object-cover" data-testid={`package-img-${p.id}`} />}
              <div className="p-6 flex flex-col flex-1">
              {p.badge && <Badge className="absolute top-4 right-4 bg-amber-100 text-amber-800 border-amber-300">{p.badge}</Badge>}
              <h3 className="font-bold text-xl pr-24">{p.name}</h3>
              <p className="text-slate-600 text-sm mt-2 leading-relaxed">{p.desc}</p>
              <ul className="mt-4 space-y-1.5 text-sm flex-1">
                {p.trips.map((tr, i) => <li key={i} className="flex items-start gap-2"><Check className="w-4 h-4 text-emerald-600 mt-0.5 shrink-0" />{tr.route}</li>)}
              </ul>
              <div className="mt-5 pt-4 border-t">
                <div className="text-xs text-slate-500">{catalog.vehicle_types[vehicleType]?.label}{savePct > 0 && ` · ${t("save_pct").replace("{n}", savePct)}`}</div>
                <div className="flex items-baseline gap-2"><span className="text-2xl font-bold text-emerald-700" data-testid={`package-price-${p.id}`}>{formatSAR(final)}</span>{final < total && <span className="text-sm text-slate-400 line-through">{formatSAR(total)}</span>}</div>
              </div>
              <Button onClick={() => nav(`/booking?package=${p.id}`)} className="mt-4 bg-emerald-600 hover:bg-emerald-700 rounded-full" data-testid={`package-book-${p.id}`}>{t("book_package")} <ArrowRight className="w-4 h-4 ml-2" /></Button>
              </div>
            </div>);
        })}
      </div>
    </section>
  );
}
